import React, { Component } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Modal } from "react-bootstrap";
import LoaderButton from "../../components/LoaderButton";
import { WhiteLabel }               from "../../utils/WhiteLabelProps";

import "../../css/modal/ModalProgramSummary.css";


var white_label = WhiteLabel();
const MainColor = white_label.company_primary_btn_color;
const CloseBtnColor = white_label.company_close_btn_color;

export default class ModalMktplcInfo extends Component {

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    getMyPrograms = () => {
        this.props.getProgramDropdown(2, "My Programs")
        this.props.onHide();
    }


    render() {

        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                style={{position:"absolute", top:140}}
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="marketplaceModalTitle">
                            Marketplace Program
                            { /*}<FontAwesomeIcon icon="sticky-note" />*/ }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                      <div className="marketplaceModalProgramSummary">
                          Congrats, you've just subscribed to the program!
                          <br/><br/>
                          The program is now located in "<b>My Programs</b>."
                      </div>
                      <br/>
                </Modal.Body>
                <Modal.Footer>
                      <LoaderButton
                          bsSize   = "large"
                          height   = "38px"
                          width    = "100px"
                          fontSize = "17px"
                          type     = "submit"
                          btncolor = { CloseBtnColor }
                          text     = "Close"
                          onClick     = {this.props.onHide}
                        />

                    &nbsp;
                      <LoaderButton
                          bsSize   = "large"
                          height   = "38px"
                          width    = "230px"
                          fontSize = "17px"
                          type     = "submit"
                          btncolor = { MainColor }
                          text     = "Go to 'My Programs'"
                          onClick  = {this.getMyPrograms}
                        />
                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalMktplcInfo.js